import { Handler, Result, ok, err, ComplexModel } from './handler';
import { Path } from './path';
import { ComplexAttribute } from './attribute';
import { SchemaError, ErrorCode } from './schema-error';

export function complex(attributes: { [ key: string ]: ComplexAttribute }) {

  const c = new Complex(attributes);
  return c;
}

export function complexAttrib(
  c: Complex,
  ...path: string[]): ComplexAttribute {

  const selector = (x: any) => x.getIn(path);
  const injector = (data: any, newMember: any) => data.setIn(path, newMember);

  const attribute = new ComplexAttribute(
    c,
    selector,
    injector
  );

  return attribute;
}

export class Complex implements Handler {

  private attributes: Map<string, ComplexAttribute>;

  constructor(attributes: { [ key: string ]: ComplexAttribute}) {

    this.attributes = new Map<string, ComplexAttribute>();
    for (const a in attributes) {
      if (!Object.keys(attributes).includes(a)) {
        continue;
      }
      this.attributes.set(a, attributes[a]);
    }
  }

  public get(path: Path, data: any): Result<string, SchemaError> {

    if (path.current === '_children') {
      return this.children();
    }

    if (path.current === '_count') {
      return err(new SchemaError(ErrorCode.elementNotAnArrayCannotHaveCount,
                                 'This is a complex type.'));
    }

    const attribute = this.attributes.get(path.current);
    if (!attribute) {
      return err(new SchemaError(ErrorCode.invalidArgumentError,
                                 `Attribute "${path.current}" does not exist.`));
    }

    return attribute.get(path, data);
  }

  public set(path: Path, current: ComplexModel, value: string): Result<ComplexModel, SchemaError> {

    if (path.current === '_count' || path.current === '_children') {
      return err(new SchemaError(ErrorCode.invalidSetElementIsKeyword,
                                 'You cannot set keyword.'));
    }

    const attribute = this.attributes.get(path.current);
    if (!attribute) {
      return err(new SchemaError(ErrorCode.invalidArgumentError,
                                 `Attribute "${path.current}" does not exist.`));
    }

    return attribute.set(path, current, value);
  }

  private children() {
    const children: string[] = [];

    for (const [ key ] of this.attributes) {
      children.push(key);
    }

    const s = children.join(',');
    return ok(s);
  }

}

